'use client'

import Script from 'next/script'
import { GTM_CONTAINER_ID, DEBUG } from '@/lib/config'

/**
 * GoogleTagManager Component
 * 
 * Loads GTM container for marketing/advertising tags.
 * This runs alongside direct GA4 tracking (hybrid approach).
 * 
 * The script is placed in <head> via Next.js Script component,
 * and the noscript fallback is placed in <body>.
 */
export default function GoogleTagManager() {
  if (DEBUG) {
    console.log('[GTM] Container ID:', GTM_CONTAINER_ID || 'missing')
  }

  if (!GTM_CONTAINER_ID) {
    if (DEBUG) {
      console.warn(
        'GTM Container ID missing - GTM disabled. ' +
        'Set NEXT_PUBLIC_GTM_CONTAINER_ID in your .env.local file.'
      )
    }
    return null
  }

  return (
    <>
      {/* GTM Script - loads in <head> */}
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_CONTAINER_ID}');
        `}
      </Script>
      
      {/* GTM Noscript fallback - loads in <body> */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}
